import * as React from "react";
const ArrowRightIcon = ({
  size = 16,
  title = "ArrowRightIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "pds-icon",
  title,
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M3.333 7.375a.625.625 0 0 0 0 1.25v-1.25ZM12.667 8l.442.442a.625.625 0 0 0 0-.884L12.667 8ZM8.442 2.891a.625.625 0 1 0-.884.884l.884-.884Zm-.884 9.334a.625.625 0 0 0 .884.884l-.884-.884Zm-4.225-3.6h9.334v-1.25H3.333v1.25Zm4.225-4.85 4.667 4.667.884-.884-4.667-4.667-.884.884Zm4.667 3.783-4.667 4.667.884.884 4.667-4.667-.884-.884Z",
  fill: "currentColor"
}));
export default ArrowRightIcon;
